import debounce from "lodash/debounce";
import React, {
  lazy,
  Suspense,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import { FormattedMessage } from "react-intl";
import iphone from "./assets/iphone_compressed.png";
import iphone2 from "./assets/iphone_compressed@2x.png";
import iphone3 from "./assets/iphone_compressed@3x.png";
import laptop from "./assets/laptop_compressed.png";
import laptop2 from "./assets/laptop_compressed@2x.png";
import laptop3 from "./assets/laptop_compressed@3x.png";
import FeatureSection, {
  ImagePosition,
} from "./components/FeatureSection/FeatureSection";
import "./PublicFeatures.scss";
const PublicLayoutContainer: React.LazyExoticComponent<any> = lazy(
  () => import("../../layouts/PublicLayoutContainer/PublicLayoutContainer")
);

const PublicFeatures = (): React.JSX.Element => {
  const [laptopVisible, setLaptopVisible] = useState(false);
  const [phoneVisible, setPhoneVisible] = useState(false);
  const laptopRef = useRef(null);
  const phoneRef = useRef(null);

  const onWindowScroll = useCallback(
    debounce(() => {
      if (isInViewport(laptopRef.current)) {
        setLaptopVisible(true);
      }

      if (isInViewport(phoneRef.current)) {
        setPhoneVisible(true);
      }

      if (laptopVisible && phoneVisible) {
        window.removeEventListener("scroll", onWindowScroll);
      }
    }, 100),
    [laptopVisible, phoneVisible]
  );

  useEffect(() => {
    window.addEventListener("scroll", onWindowScroll);
    return () => {
      window.removeEventListener("scroll", onWindowScroll);
    };
  }, [onWindowScroll]);

  const isInViewport = (element: any): boolean => {
    const offset = 40;
    if (!element) return false;
    const top = element.getBoundingClientRect().top;
    return top + offset >= 0 && top - offset <= window.innerHeight;
  };

  return (
    <div className="public-features">
      <Suspense fallback={<div className="fallback">loading...</div>}>
        <PublicLayoutContainer>
          <span ref={laptopRef}>
            <FeatureSection
              title={
                <FormattedMessage
                  tagName="span"
                  id="home-features-feature1-title"
                />
              }
              text={
                <>
                  <FormattedMessage
                    tagName="span"
                    id="home-features-feature1-text-1"
                  />
                  <FormattedMessage
                    tagName="span"
                    id="home-features-feature1-text-2"
                  />
                  <FormattedMessage
                    tagName="span"
                    id="home-features-feature1-text-3"
                  />
                </>
              }
              imageSrc={laptop}
              imageSrcSet={`${laptop2} 2x, ${laptop3} 3x`}
              isVisible={laptopVisible}
              imagePosition={undefined}
            />
          </span>
          <span ref={phoneRef}>
            <FeatureSection
              title={
                <FormattedMessage
                  tagName="span"
                  id="home-features-feature2-title"
                />
              }
              text={
                <>
                  <FormattedMessage
                    tagName="span"
                    id="home-features-feature2-text-1"
                  />
                  <FormattedMessage
                    tagName="span"
                    id="home-features-feature2-text-2"
                  />
                  <FormattedMessage
                    tagName="span"
                    id="home-features-feature2-text-3"
                  />
                </>
              }
              imageSrc={iphone}
              imageSrcSet={`${iphone2} 2x, ${iphone3} 3x`}
              imagePosition={ImagePosition.LEFT}
              isVisible={phoneVisible}
            />
          </span>
        </PublicLayoutContainer>
      </Suspense>
    </div>
  );
};

export default PublicFeatures;
